/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SessionsService {

    /**
     * create a new user session
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postInternalApiWxSessions(
        requestBody?: {
            jwt: string;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/wx/sessions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                302: `redirect`,
                401: `unauthorized`,
                404: `not found`,
            },
        });
    }

}